import { PolicyFlowApproval } from 'src/types'

export default function sanitize(values: PolicyFlowApproval) {
  try {
    const sanitized = JSON.parse(JSON.stringify(values))
    delete sanitized.key
    sanitized.policy_approval_id = +values.policy_approval_id || null
    return sanitized
  } catch (err) {
    //send bugsnag
  }
}
